import React from "react";
import Icon from "../../../common/Icon";
import "./LicenseFilterCards.css";

interface LicenseFilterCardsProps {
  counts?: {
    total_licenses: number;
    active_licenses: number;
    perpetual_licenses: number;
    up_for_renewal: number;
  };
  isLoading?: boolean;
  onFilterChange?: (filterType: string | null) => void;
  activeFilter?: string | null;
}

const LicenseFilterCards: React.FC<LicenseFilterCardsProps> = ({
  counts = {
    total_licenses: 0,
    active_licenses: 0,
    perpetual_licenses: 0,
    up_for_renewal: 0,
  },
  isLoading = false,
  onFilterChange,
  activeFilter = null,
}) => {
  const displayValue = (value: number) => {
    return isLoading ? "..." : value;
  };

  const handleCardClick = (filterType: string | null) => {
    if (onFilterChange) {
      onFilterChange(activeFilter === filterType ? null : filterType);
    }
  };

  return (
    <div className="d-flex mb-2 card-container" style={{ gap: "12px" }}>
      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === null ? 'active-card' : ''}`}
        onClick={() => handleCardClick(null)}
      >
        <div className="icon-container">
          <Icon name={"totallicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">{displayValue(counts.total_licenses)}</h4>
          <p className="m-0">Total Licenses</p>
        </div>
      </div>

      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === 'active' ? 'light_green' : ''}`}
        onClick={() => handleCardClick('active')}
      >
        <div className="icon-container light_green">
          <Icon name={"activelicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">{displayValue(counts.active_licenses)}</h4>
          <p className="m-0">Active Licenses</p>
        </div>
      </div>

      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === 'perpetual' ? 'light_grey' : ''}`}
        onClick={() => handleCardClick('perpetual')}
      >
        <div className="icon-container light_grey">
          <Icon name={"perpetuallicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">{displayValue(counts.perpetual_licenses)}</h4>
          <p className="m-0">Perpetual Licenses</p>
        </div>
      </div>

      <div
        className={`cards d-flex align-items-center border-0 cursor-pointer ${activeFilter === 'up_for_renewal' ? 'light_orange' : ''}`}
        onClick={() => handleCardClick('up_for_renewal')}
      >
        <div className="icon-container light_orange">
          <Icon name={"upforlicense"} />
        </div>
        <div>
          <h4 className="fs-4 fw-semibold">
            {displayValue(counts.up_for_renewal)}
          </h4>
          <p className="m-0">Up for renewal</p>
        </div>
      </div>
    </div>
  );
};

export default LicenseFilterCards;
